import createReactComponent from '../createReactComponent';
export default createReactComponent('slash-circle', 'SlashCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M9 15l6-6","key":"svg-0"}]]);